import React, { useContext, useEffect, useState } from "react";
import { Box, Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import Controls from "../../../components/controls/Controls";
import PersonalAddressDataStep from "./steps/PersonalAddressDataStep";
import { RecadastramentoStepForm } from "../../../config/RecadastramentoStepForm";
import { useHistory } from "react-router-dom";
import { ConfirmModalHandle } from "../../../components/controls/ConfirmModal";
import { RecadastramentoContext } from "../../../context/RecadastramentoContext";
import GuideStep from "./steps/GuideStep";
import { AppThemeLoggedAreationProvider } from "../../../context/ThemeLoggedAreaContext";
import BusinessAddressDataStep from "./steps/BusinessAddressDataStep";
import AcademicDegreeVocationalTraningStep from "./steps/AcademicDegreeVocationalTraningStep";
import TmpStepButtonsCustom from "../../../components/tempo/TmpStepButtonsCustom/TmpStepButtonsCustom";
import TmpLoadingCustom from "../../../components/tempo/TmpLoadingCustom/TmpLoadingCustom";
import MedicalTeamStep from "./steps/MedicalTeamStep";
import ReRegistrationAttachmentDataStep from "./steps/ReRegistrationAttachmentDataStep";
import TmpModalCustom from "../../../components/tempo/TmpModalCustom/TmpModalCustom";
import TmpTypographyCustom from "../../../components/tempo/TmpTypographyCustom/TmpTypographyCustom";
import TmpIconCustom from "../../../components/tempo/TmpIconCustom/TmpIconCustom";
import { ReactComponent as IconAtencao } from "../../../assets/icons/info.svg";
import { ReactComponent as IconSucesso } from "../../../assets/icons/sucesso.svg";
import ProfessionalPrivilegeStep from "./steps/ProfessionalPrivilegeStep";
import TmpStepCustom from "../../../components/tempo/TmpStepCustom/TmpStepCustom";
import RequestService from "../../../services/RequestService";
import TmpAlertCustom from "../../../components/tempo/TmpAlertCustom/TmpAlertCustom";
import { APP_ACCESS_TOKEN__LOCALSTORAGE_KEY } from "../../../context/AuthContext";



export default function RecadastramentoSteps() {
  const { state, dispatch, nextStep, handleSetRequestIdAndProfessionalId, validateCurrentForm } = useContext(RecadastramentoContext);
  const [currentComponent, setCurrentComponent] = useState(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isOpenAlert, setIsOpenAlert] = useState<boolean>(false)
  const [messageAlert, setMessageAlert] = useState<string>("")
  const modalRef = React.createRef<ConfirmModalHandle>();
  const [_isOpenedModalConfirm, setIsOpenedModalConfirm] = useState(false);
  const [_isOpenedModalEnvioComSucesso, setIsOpenedModalEnvioComSucesso] = useState(false);
  const [protocol, setProtocol] = useState<string>("");
  const history = useHistory();
  const [steps, setSteps] = useState<any[]>();

  useEffect(() => {

    dispatch({
      type: "RESET_STATE",
    });


    const queryParameters = new URLSearchParams(window.location.search)
    const requestId = queryParameters.get("requestId")
    const professionalId = queryParameters.get("professionalId")

    if (requestId !== null && professionalId !== null) {
      handleSetRequestIdAndProfessionalId(requestId, professionalId);

      RequestService.getRequestById(requestId).then((result) => {

        //Siginifica que a requisição não não está mais em preenchimento
        if (result.requestState !== 1) {
          setIsOpenAlert(true);
          setMessageAlert("Sua solicitação não pode ser editada até o fim da análise.")

          setTimeout(() => {
            history.push(`/userhome`);
          }, 4000);

        }
      });

    }

  }, []);


  useEffect(() => {
    setIsLoading(state.Loading)

  }, [state.Loading]);


  useEffect(() => {

    const stepsAux: any[] = [];
    RecadastramentoStepForm.forEach(function (stepConfig) {
      stepsAux?.push({ label: stepConfig.description });
    });
    setSteps(stepsAux);
  }, []);


  //Ação: Confirmar o envio da solicitação para análise
  const onConfirmToFinishClick = () => {
    setIsOpenedModalConfirm(false);
    nextStep();
  }

  //Ação: Acionado ao clicar no botão avançar
  const onNextClick = () => {
    nextStep();
  };

  //Ação: Se o usuário desejar sair, irá para a tela principal na área logada
  const GoToUserHome = () => {
    history.push("/userhome");
  };

  //Ação: Responável por retornar uma etapa, se for a primeira, irá apresentar uma modal de confirmação
  const onToBackClick = () => {
    if (state.CurrentStep === 1) {
      modalRef.current?.handleOpen();
    } else {
      dispatch({
        type: "GO_TO_BACK_STEP",
      });
    }
  };

  //Ação: Método acionado ao clicar no botão avançar na última etapa do formulário
  const onToFinishClick = () => {
    //Se for a ultima etapa apresentar a modal de confirmação
    if (validateCurrentForm().length === 0) {
      setIsOpenedModalConfirm(true);
    }
  };

  const alertUser = (event: any) => {

    const accessTokenLocal = localStorage.getItem(APP_ACCESS_TOKEN__LOCALSTORAGE_KEY);

    if (accessTokenLocal !== "" && accessTokenLocal !== undefined && accessTokenLocal !== null) {
      event.returnValue = "Você tem certeza que deseja sair do formulário ? Todas as suas informações serão perdidas.";
      event.preventDefault();
    }
  };

  useEffect(() => {

   
    window.addEventListener("beforeunload", alertUser);
    return () => {
      window.removeEventListener("beforeunload", alertUser);
    };
  }, []);

  useEffect(() => {
    if (state.Protocol !== "") {
      //history.push({pathname: "/protocolo", state: {protocol: state.Protocol}});
      setProtocol(state.Protocol);
      setIsOpenedModalEnvioComSucesso(true);
    } else {
      let component: any = null;

      window.scrollTo(0, 0);

      let mainStep = RecadastramentoStepForm.find((c) => c.key === state.CurrentStep)?.mainStep;

      switch (mainStep) {
        case "GuideStep":
          component = <GuideStep />;
          break;
        case "PersonalAddressDataStep":
          component = <PersonalAddressDataStep />;
          break;
        case "BusinessAddressDataStep":
          component = <BusinessAddressDataStep />;
          break;
        case "AcademicDegreeVocationalTraningStep":
          component = <AcademicDegreeVocationalTraningStep />;
          break;
        case "MedicalTeamStep":
          component = <MedicalTeamStep />;
          break;
        case "ProfessionalPrivilegeStep":
          component = <ProfessionalPrivilegeStep />;
          break;
        case "ReRegistrationAttachmentDataStep":
          component = <ReRegistrationAttachmentDataStep />;
          break;
        default:
          break;
      }

      setCurrentComponent(component);
    }
  }, [state.CurrentStep, state.Protocol]);

  return (
    <AppThemeLoggedAreationProvider>
      <Box mt={3}>

        <Box mb={4} display="flex" justifyContent="center" >

          {steps !== undefined && steps?.length > 0 ?
            <TmpStepCustom
              current={state.CurrentStep}
              steps={steps}
            />
            : null}

        </Box>
        <Box >{currentComponent}</Box>
        <Grid item>
          {state.MessageErrorToGoStep.length > 0
            ? state.MessageErrorToGoStep.map((message, index) => (
              <div key={index}>
                <Box mt={2}>
                  <Alert severity="error">
                    <AlertTitle>Atenção</AlertTitle>
                    {message}
                  </Alert>
                </Box>
              </div>
            ))
            : null}

          <Box mt={2}>
            <TmpStepButtonsCustom
              currentStep={state.CurrentStep}
              totalSteps={RecadastramentoStepForm.length}
              isLoading={state.Loading}
              onNextClick={onNextClick}
              onBackClick={onToBackClick}
              onFinishClick={onToFinishClick}
            />


          </Box>
        </Grid>

        <Controls.ConfirmModal
          ref={modalRef}
          onConfirmClick={GoToUserHome}
          title="Confirmar a saída do formulário"
          message="Você tem certeza que deseja sair do formulário ? Todas as suas informações serão perdidas."
        />
      </Box>
      <TmpLoadingCustom label="Aguarde, carregando informações da solicitação" loading={isLoading} />

      {/* Modal de Confirmação para o Envio da solicitação para análise */}
      <TmpModalCustom
        isDoubleAction={true}
        isOpened={_isOpenedModalConfirm}
        size="md"
        handleConfirm={onConfirmToFinishClick} handleCancel={() => setIsOpenedModalConfirm(false)}
        labelPrimary="Confirmar o envio da solicitação"
        labelSecondary="Voltar"  >

        <div style={{ textAlign: "center" }}>
          <TmpIconCustom icon={<IconAtencao />} size="xg" />
          <TmpTypographyCustom component="heading" size="small" variant="h4" id="mensagem-6">
            Enviar solicitação para análise
          </TmpTypographyCustom>

        </div>
        <Box marginTop={5}>
          <TmpTypographyCustom component="paragraph" size="medium" variant="h4" id="mensagem-7">
            Após o envio da solicitação para análise você receberá um protocolo para acompanhamento.
            Após a análise da equipe do SAM, os seus dados serão integrados ao Tasy. Caso alguma informação precise de alteração, a equipe do SAM entrará em contato.
          </TmpTypographyCustom>
        </Box>

      </TmpModalCustom>
      {/* Modal de Confirmação para o Envio da solicitação para análise */}

      {/* Modal de sucesso ao enviar a solicitação para análise */}
      <TmpModalCustom
        isDoubleAction={false}
        isOpened={_isOpenedModalEnvioComSucesso}
        size="md"
        handleConfirm={GoToUserHome} handleCancel={() => GoToUserHome()}
        labelPrimary="Ir para o início">

        <div style={{ textAlign: "center" }}>
          <TmpIconCustom icon={<IconSucesso style={{ color: "#2c6ef2" }} />} size="xg" />
          <Box marginTop={2}>
            <TmpTypographyCustom component="heading" size="medium" variant="h4" id="mensagem-1">
              Solicitação enviada com sucesso!
            </TmpTypographyCustom>
          </Box>

          <Box marginTop={2}>
            <TmpTypographyCustom component="heading" size="medium" variant="h4" id="mensagem-2">
              Protocolo: {protocol}
            </TmpTypographyCustom>
          </Box>

          <Box marginTop={2}>
            <TmpTypographyCustom component="paragraph" size="small" variant="h4" id="mensagem-3">
              Agora você pode acompanhar o status da sua solicitação e em caso de dúvidas entre em contato pelo telefone:
            </TmpTypographyCustom>
          </Box>

          <TmpTypographyCustom component="paragraph" size="small" variant="h4" id="mensagem-4">
            <strong>São Paulo +55 (11) 3394-1000 - sam@hsl.org.br</strong>
          </TmpTypographyCustom>
          <TmpTypographyCustom component="paragraph" size="small" variant="h4" id="mensagem-5">
            <strong>Brasília +55 (61) 3044-8888 (opção 6) - sambrasilia@hsl.org.br</strong>
          </TmpTypographyCustom>
        </div>

      </TmpModalCustom>
      {/* Modal de sucesso ao enviar a solicitação para análise */}

      <TmpAlertCustom isOpened={isOpenAlert} message={messageAlert} title="Atenção" type="error"></TmpAlertCustom>
    </AppThemeLoggedAreationProvider>
  );
}
